import { useEffect, useState } from "react";

export const UserDemographicSettings = ({ userID, professions, regions, associations }) => {

  const tangibleFields = window.tangibleFields
  const [ saving, setSaving ] = useState(false)
  const [ availableProfessions, setAvailableProfessions ] = useState({})

  useEffect(() => {
    // Update field and remove professions that are no longer valid
    let selectedProfessions = tangibleFields.store.getValue('tgbl_user_demographic_professions')
    if ( selectedProfessions !== '' ) {
      tangibleFields.store.setValue('tgbl_user_demographic_professions', selectedProfessions
        .split(',')
        .filter( profession => availableProfessions[profession] !== undefined )
        .toString()
      )

    } else {
      tangibleFields.fields.rerender('tgbl_user_demographic_professions')
    }

  }, [ availableProfessions ])

  const regionField = tangibleFields.render({
    type: 'combo-box',
    name: 'tgbl_user_demographic_regions',
    label: 'State',
    multiple: true,
    choices: regions.reduce((obj, region) => { return { ...obj, [`r-${region.id}`]: region.name }}, {}),
    onChange: value => {
      // console.log(associations)
      let validProfessions = new Set()
      if ( value !== '' ) value.replaceAll('r-', '').split(',').forEach( region => {
        if ( associations[region] ) Object.keys(associations[region]).forEach( profession => validProfessions.add(profession) )
      })

      const newOptions = professions.reduce((obj, profession) => {
        if ( !validProfessions.has(profession.id.toString())) return obj
        return { ...obj, [`p-${profession.id}`]: profession.name }
      }, {})
      setAvailableProfessions( prev => {
        if ( JSON.stringify(prev) === JSON.stringify(newOptions) ) return prev
        return newOptions
      })
    }
  })

  const professionField = tangibleFields.render({
    type: 'combo-box',
    name: 'tgbl_user_demographic_professions',
    label: 'Profession',
    multiple: true,
    choices: availableProfessions
  })

  useEffect(() => {
    setTimeout(() => {
      const savedData = JSON.parse(tangibleFields.store.getValue("tgbl_user_demographic_data"));
      if ( savedData.professions ) tangibleFields.store.setValue(
        "tgbl_user_demographic_professions",
        savedData.professions.reduce((value, profession) => value === '' ? `p-${profession}` : `${value},p-${profession}`, '')
      )
      if ( savedData.regions ) tangibleFields.store.setValue(
        "tgbl_user_demographic_regions",
        savedData.regions.reduce((value, region) => value === '' ? `r-${region}` : `${value},r-${region}`, '')
      )
    }, 100)
  }, [])

  const saveSettings = () => {
    if ( saving ) return
    setSaving(true)

    const ajax = window.Tangible.ajax
    ajax( 'tgbl_cred_save_user_demographic_settings', {
      user_id: userID,
      professions: tangibleFields.store.getValue('tgbl_user_demographic_professions').replaceAll('p-', ''),
      regions: tangibleFields.store.getValue('tgbl_user_demographic_regions').replaceAll('r-', ''),
    })
      .then( result => {
        setSaving(false)
      })
      .catch( error => {
        setSaving(false)
        console.error(error)
      })
  }

  return <div className={`tgbl-interface tgbl-user-demographic-settings-fields ${ saving ? 'tgbl-user-demographic-settings-fields--saving' : ''}`}>
    <h2>Your State and Profession</h2>

    <div className="tgbl-user-demographic-settings-fields__inner">
      { regionField }
      { professionField }
    </div>

    <button
      className="tgbl-button tgbl-button--theme-primary tgbl-button--style-rounded" type="button"
      disabled={saving}
      onClick={saveSettings}
    >
      { saving
        ? <>Saving<div className="tgbl-button__spinner"/></>
        : <>Save State & Profession</>
      }
    </button>
  </div>
}
